// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#cctv_status_box[data-v-0ff0cc52] {\n  background-color: #34363C;\n  color: white;\n  border-radius: 5px;\n}\n#chart_box[data-v-0ff0cc52] {\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
